module.exports = __webpack_public_path__ + "img/appAsset--compliance--flow-connector--failed--yellow.2baba65c.svg";